/*!
 * devextreme-angular
 * Version: 24.2.7
 * Build date: Mon Apr 28 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import { SubmenuShowMode } from 'devextreme/common';

import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-show-submenu-mode',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoShowSubmenuModeComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get delay(): number | { hide?: number, show?: number } {
        return this._getOption('delay');
    }
    set delay(value: number | { hide?: number, show?: number }) {
        this._setOption('delay', value);
    }

    @Input()
    get name(): SubmenuShowMode {
        return this._getOption('name');
    }
    set name(value: SubmenuShowMode) {
        this._setOption('name', value);
    }


    protected get _optionPath() {
        return 'showSubmenuMode';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoShowSubmenuModeComponent
  ],
  exports: [
    DxoShowSubmenuModeComponent
  ],
})
export class DxoShowSubmenuModeModule { }
